import { Stack, Typography } from '@mui/material';
import { ReactNode } from 'react';

type Props = {
  title: string;
  children: ReactNode;
};

export const Section = ({ title, children }: Props) => (
  <Stack direction='column' spacing={1}>
    <Typography
      variant='overline'
      sx={{ color: 'text.secondary', letterSpacing: 1, lineHeight: 1.5 }}
    >
      {title}
    </Typography>
    <Stack direction='column' spacing={1.25}>
      {children}
    </Stack>
  </Stack>
);
